export default __webpack_public_path__ + "static/media/SOCIALSECURITYCERTIFICATE_BACK.891d8175.png";